import { useEffect, useState } from "react";

let tokenValue: string = "";
let listener: ((val: string) => void) | null;

// Hàng đợi "token sẵn sàng": các request g-process bắn QUÁ SỚM (vd Sidebar gọi manager-status
// lúc app shell mount, trước khi generateGprocessToken xong) sẽ chờ promise này thay vì 401.
// Xem request interceptor trong features/g-process/component/api/axios.ts.
let readyPromise: Promise<void> | null = null;
let resolveReady: (() => void) | null = null;

export const setToken = (nextToken: string) => {
  tokenValue = nextToken;
  if (listener) {
    listener(tokenValue);
  }
  if (nextToken) {
    // Token vừa có → giải phóng mọi request đang xếp hàng.
    if (resolveReady) {
      resolveReady();
      resolveReady = null;
    }
  } else {
    // Token bị xoá (đăng xuất) → chuẩn bị chờ lại cho lần đăng nhập sau.
    readyPromise = null;
    resolveReady = null;
  }
};

export const getGprocessToken = (): string => tokenValue;

/**
 * Resolve NGAY nếu token g-process đã có; nếu chưa, resolve khi `setToken` được gọi với token.
 * Dùng để xếp hàng request cho tới khi có token (tránh gọi quá sớm → 401).
 */
export const whenGprocessTokenReady = (): Promise<void> => {
  if (tokenValue) {
    return Promise.resolve();
  }
  if (!readyPromise) {
    readyPromise = new Promise<void>((resolve) => {
      resolveReady = resolve;
    });
  }
  return readyPromise;
};

export function useGetGprocessToken() {
  const [token, setTokenState] = useState(tokenValue);

  useEffect(() => {
    listener = (val: string) => {
      setTokenState(val);
    };

    return () => {
      listener = null;
    };
  }, []);

  return { token };
}
